import { Column, ColumnKeys } from './grid-config';
import { DiscoveredDeviceItem } from '@nirvana/shared/dtos/types/policies/common';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
} from '../../../../../../../../grid/types/common';
import {
  DiscoveredDevicesApiClients,
  PolicyDependenciesContainer,
} from '../../../../../../../common/policyPanel/uiSettings/dependencies/PolicyDependenciesContainer';
import { GridBaseDataProvider } from '../../../../../../../../grid/GridBaseDataProvider';
import { convertGridFiltersToExtJsFilters } from '../../../../../../../../grid/utils/filters';

export class DiscoveredDevicesGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  protected items: DiscoveredDeviceItem[];
  protected clients: DiscoveredDevicesApiClients;

  constructor() {
    super();
    this.clients = PolicyDependenciesContainer.getInstance().resolveDependency(
      'DiscoveredDevices'
    ) as DiscoveredDevicesApiClients;
  }
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    if (!this.items) {
      console.error('No cached response');
    }
    return { rawEvents: this.items };
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<any> {
    return {};
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    const params = {
      filter: convertGridFiltersToExtJsFilters(request.filters),
      limit: request.pageSize,
      page: request.pageNumber,
      sort: request.sortColumnName,
      dir: request.sortDirection,
    };

    const response = await this.clients.ReadDiscoveredDevices(params);

    this.items = response.data;

    return {
      summary: 'no Summary',
      numItems: response.total,
    };
  }
}
